import { shallow } from "zustand/shallow";
import { createWithEqualityFn as create } from "zustand/traditional";

export interface ReopenModalParams {
  lenderApplicationId: number;
  lenderCompanyId: number;
}

export interface RejectAfterWinningModalParams {
  lenderApplicationId: number;
  lenderCompanyId: number;
}

export interface DeleteBidModalParams {
  lenderApplicationId: number;
  lenderResponseId: number;
  lenderCompanyId: number;
}

export type ModalParams =
  | { type: "reopen"; params: ReopenModalParams }
  | { type: "rejectAfterWinning"; params: RejectAfterWinningModalParams }
  | { type: "deleteBid"; params: DeleteBidModalParams };

interface IModalStore {
  modalParams: ModalParams | null;
  loading: boolean;
}

const initialState: IModalStore = {
  modalParams: null,
  loading: false,
};

interface IModalStoreActions {
  showReopenModal: (params: ReopenModalParams) => void;
  showRejectAfterWinningModal: (params: RejectAfterWinningModalParams) => void;
  showDeleteBidModal: (params: DeleteBidModalParams) => void;
  setModalLoading: (loading: boolean) => void;
  closeModal: () => void;
}

export const useModalStore = create<IModalStore & IModalStoreActions>(
  (set) => ({
    ...initialState,
    showReopenModal: (params) =>
      set({ modalParams: { type: "reopen", params } }),
    showRejectAfterWinningModal: (params) =>
      set({ modalParams: { type: "rejectAfterWinning", params } }),
    showDeleteBidModal: (params) =>
      set({ modalParams: { type: "deleteBid", params } }),
    setModalLoading: (loading) => set({ loading }),
    closeModal: () => set(initialState),
  }),
  shallow,
);
